import { render, staticRenderFns } from "./supportTool.vue?vue&type=template&id=0073e406&scoped=true"
import script from "./supportTool.vue?vue&type=script&lang=js"
export * from "./supportTool.vue?vue&type=script&lang=js"
import style0 from "./supportTool.vue?vue&type=style&index=0&id=0073e406&prod&lang=scss"
import style1 from "./supportTool.vue?vue&type=style&index=1&id=0073e406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073e406",
  null
  
)

export default component.exports